import { render, staticRenderFns } from "./SchemePension.vue?vue&type=template&id=68d3351c&scoped=true"
import script from "./SchemePension.vue?vue&type=script&lang=js"
export * from "./SchemePension.vue?vue&type=script&lang=js"
import style0 from "./SchemePension.vue?vue&type=style&index=0&id=68d3351c&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../Retirement Planner.Admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d3351c",
  null
  
)

export default component.exports